<form>
  <mat-form-field>
    <mat-label>{{ title }}</mat-label
    ><input
      *ngIf="required; else optionalField"
      type="text"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      (blur)="onBlur()"
      required
    />
    <ng-template #optionalField>
      <input
        type="text"
        matInput
        [formControl]="control"
        [matAutocomplete]="auto"
        (blur)="onBlur()"
      />
    </ng-template>
    <mat-autocomplete
      autoActiveFirstOption
      #auto="matAutocomplete"
      [displayWith]="displayFn"
    >
      <mat-option disabled class="loading" *ngIf="loading">
        <mat-spinner diameter="25"></mat-spinner>
      </mat-option>
      <mat-option
        *ngFor="let data of dataContent$ | async"
        (onSelectionChange)="handleChange($event, data)"
        [value]="data"
      >
        {{ data.label }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="!control.valid"
      >{{ title }} {{ "is-required" | translate }}</mat-error
    >
  </mat-form-field>
</form>
